module.exports = __webpack_public_path__ + "img/applySignature.e82ddc1d.png";